import { render, staticRenderFns } from "./manifest-item.vue?vue&type=template&id=4e3e0606"
import script from "./manifest-item.vue?vue&type=script&lang=js"
export * from "./manifest-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports